import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import api from "./api";
import { useAppSelector } from "../redux/hooks";

export const FollowPixel = () => {
  const location = useLocation();
  const user = useAppSelector((state) => state.user);

  const sendFollow = (path: string) => {
    const payload = {
      url: path,
    };
    // Fire-and-forget telemetry: swallow failures (e.g. 403) so they don't
    // surface as unhandled promise rejections and flood Sentry (TRELLIS-UI-3MN).
    void api.post("/merchandise/follow/log", payload).catch(() => {});
  };

  useEffect(() => {
    if (!user.user_id || !user.organization_id) return;

    sendFollow(location.pathname);
  }, [location, user]);

  return null;
};
